import React, { useEffect } from 'react';

import PropTypes from 'prop-types';

import ModalComponent from 'apps/auth/components/utils/ModalComponent';

const KlarnaModal = (props) => {
    useEffect(() => {
        const handleMessage = (event) => {
            if (event?.data === 'closeIframeWindow') {
                props.modalRef.current?.close();
            }
        };

        window.addEventListener('message', handleMessage);

        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);
    return (
        <ModalComponent canCloseModal={false} modalRef={props.modalRef} fullSizeModal>
            <iframe src={props.iframeLink} style={{ width: '100%', height: '100%', border: 'none' }} title={''} />
        </ModalComponent>
    );
};

KlarnaModal.propTypes = {
    modalRef: PropTypes.shape({ current: PropTypes.object }),
    iframeLink: PropTypes.string,
};

export default KlarnaModal;
